import { LeadFormData } from 'pages/LeadForm/schema'

import { LeadMortgageData } from './types'

export const mapLeadFormToMortgageData = (data: LeadFormData): LeadMortgageData => ({
  nome: data.firstName,
  sobrenome: data.lastName,
  telefone: data.phone,
  email: data.email,
  valorImovel: parseFloat(data.purchasePrice),
  canalContato: data.contactMethod,
  possuiImovel: data.hasProperty,
})
